/* ROX Premium — Quick Add (Agregar al carrito sin entrar al producto)
   Compatible con Dawn + apps de carrito (Monster Cart, etc.).
   Defensivo: actualiza la burbuja del carrito y notifica al tema/apps. */
(function () {
  'use strict';

  function flash(btn, text, revert) {
    var original = btn.getAttribute('data-rox-label') || btn.textContent;
    if (!btn.getAttribute('data-rox-label')) btn.setAttribute('data-rox-label', original);
    btn.textContent = text;
    if (revert) {
      setTimeout(function () {
        btn.textContent = btn.getAttribute('data-rox-label');
        btn.disabled = false;
      }, 1700);
    }
  }

  async function refreshCartBubble() {
    try {
      var res = await fetch((window.shopUrl || '') + '/?sections=cart-icon-bubble');
      if (!res.ok) return;
      var data = await res.json();
      var html = data['cart-icon-bubble'];
      if (!html) return;
      var temp = document.createElement('div');
      temp.innerHTML = html;
      var fresh = temp.querySelector('.shopify-section') || temp;
      ['#cart-icon-bubble', '.cart-count-bubble'].forEach(function (sel) {
        var current = document.querySelector(sel);
        var next = fresh.querySelector(sel);
        if (current && next) current.innerHTML = next.innerHTML;
      });
    } catch (e) { /* silencioso */ }
  }

  async function addToCart(id, btn) {
    if (!id) return;
    btn.disabled = true;
    flash(btn, 'Agregando…', false);
    try {
      var res = await fetch((window.shopUrl || '') + '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
      });
      if (!res.ok) throw new Error('add_failed');
      var line = await res.json();

      flash(btn, '✓ Agregado', true);
      refreshCartBubble();

      // Notificar al tema (Dawn pub/sub) y a apps de carrito
      try {
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('rox:cart:added', { bubbles: true, detail: line }));
        if (window.Shopify && typeof window.Shopify.onItemAdded === 'function') {
          window.Shopify.onItemAdded(line);
        }
      } catch (e) {}
    } catch (e) {
      flash(btn, 'No disponible', true);
    }
  }

  // --- Hoja inferior de tallas (móvil) ---
  var backdrop = null;
  function getBackdrop() {
    if (!backdrop) {
      backdrop = document.createElement('div');
      backdrop.className = 'rox-sheet-backdrop';
      backdrop.addEventListener('click', closeSheet);
      document.body.appendChild(backdrop);
    }
    return backdrop;
  }
  function closeSheet() {
    document.querySelectorAll('.rox-quickadd__sizes.is-open').forEach(function (s) {
      s.classList.remove('is-open');
    });
    document.querySelectorAll('.rox-quickadd.is-open').forEach(function (w) {
      w.classList.remove('is-open');
    });
    if (backdrop) backdrop.classList.remove('is-open');
  }
  function openSheet(sizes, wrap) {
    closeSheet();
    var bd = getBackdrop();
    // forzar reflow para que la transición del fondo se vea
    void bd.offsetWidth;
    bd.classList.add('is-open');
    sizes.classList.add('is-open');
    wrap.classList.add('is-open');
  }

  document.addEventListener('click', function (e) {
    var addEl = e.target.closest('[data-rox-add]');
    if (addEl) {
      e.preventDefault();
      addToCart(addEl.getAttribute('data-rox-add'), addEl);
      closeSheet();
      return;
    }
    var toggle = e.target.closest('[data-rox-toggle]');
    if (toggle) {
      e.preventDefault();
      var wrap = toggle.closest('[data-rox-quickadd]');
      if (wrap) {
        var sizes = wrap.querySelector('.rox-quickadd__sizes');
        if (sizes) {
          if (sizes.classList.contains('is-open')) closeSheet();
          else openSheet(sizes, wrap);
        }
      }
      return;
    }

    var swatch = e.target.closest('.rox-swatch[data-rox-swap]');
    if (swatch) {
      e.preventDefault();
      var card = swatch.closest('[data-rox-card]');
      var mainImg = card && card.querySelector('[data-rox-main-img]');
      if (mainImg) {
        mainImg.src = swatch.getAttribute('data-rox-swap');
        mainImg.removeAttribute('srcset');
      }
      var group = swatch.closest('[data-rox-swatches]');
      if (group) group.querySelectorAll('.rox-swatch').forEach(function (s) { s.classList.remove('is-active'); });
      swatch.classList.add('is-active');
    }
  });
})();
